require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
require('../../modules/es.promise');
require('../../modules/es.promise.all-settled');
require('../../modules/es.promise.finally');
var path = require('../../internals/path');

module.exports = path.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/es/promise/index.js
// module id = 1290
// module chunks = 1